export default function CollectedInformation() {
    return (
        <section id="collected-information" data-testid="collected-information">
            <h2>I. QUAIS DADOS UTILIZAMOS</h2>
            <p>
                A AMBEV poderá coletar as informações inseridas ativamente pelo
                Usuário no momento do cadastro e, ainda, informações coletadas
                automaticamente quando da utilização do App e da rede, como, por
                exemplo, IP com data e hora da conexão, entre outras.
            </p>
            <p>
                Há, assim, o tratamento de dois tipos de dados pessoais: (i)
                aqueles fornecidos pelo próprio Usuário; e (ii) aqueles
                coletados automaticamente.
            </p>
            <p>
                (i) Informações fornecidas pelo Usuário: A AMBEV coleta o
                e-mail, o nome cadastrado pelo usuário e o telefone de contato.
            </p>
            <p>
                A AMBEV fará uso dessas informações para viabilizar a utilização
                do App e de suas ferramentas pela empresa e gestores (usuários
                cadastrados). Ainda, a AMBEV também fará uso das informações
                coletadas para o envio de informações relativas à utilização dos
                recursos disponibilizados pelo próprio App.
            </p>
            <p>
                (ii) Dados coletados automaticamente: A AMBEV também coleta uma
                série de informações de modo automático, tais como:
                características do dispositivo de acesso, do navegador, IP (com
                data e hora), origem do IP, dados do GPS informações sobre
                cliques, páginas acessadas, as páginas seguintes acessadas após
                a saída do App, ou qualquer termo de procura digitado nos Apps
                ou em referência a estes, dentre outros. Para tal coleta, a
                AMBEV fará uso de algumas tecnologias padrões, como cookies,
                pixel tags, beacons e local shared objects, que são utilizadas
                com o propósito de melhorar a experiência de navegação do
                Usuário no App, de acordo com seus hábitos e suas preferências.
            </p>
            <p>
                É possível desabilitar, por meio das configurações de seu
                navegador de internet, a coleta automática de informações por
                meio de algumas tecnologias, como cookies e caches, bem como em
                nosso próprio webApp, especificamente quanto aos cookies. No
                entanto, o Usuário deve estar ciente de que, se desabilitadas
                estas tecnologias, alguns recursos oferecidos pelo App, que
                dependem do tratamento dos referidos dados, poderão não
                funcionar corretamente.
            </p>
            <p>
                As informações coletadas poderão ser compartilhadas pela AMBEV
                com: (i) parceiros da iniciativa Smart Cargas (ii) demais
                empresas parceiras, quando forem necessárias para a adequada
                prestação dos serviços objeto de suas atividades; (iii) para
                proteção dos interesses da AMBEV em qualquer tipo de conflito;
                (iv) mediante decisão judicial ou requisição de autoridade
                competente.
            </p>
            <p>
                Ainda, esclarecemos que suas informações também poderão ser
                compartilhadas com empresas provedoras de infraestrutura
                tecnológica e operacional necessária para as atividades da
                AMBEV, como intermediadoras de pagamento e provedores de serviço
                de armazenamento de informações.
            </p>
        </section>
    );
}
